import { UserResumeOrigin, UserResumeValidationStatus } from '../types/models/user-resume.js';

export const ACCEPTED_RESUME_FILE_TYPES = ['pdf'];
export const ACCEPTED_RESUME_MAX_SIZE = 10 * 1024 * 1024; // 10MB
export const DEFAULT_CV_VALIDATION_THRESHOLD = 75;

export const USER_RESUME_VALIDATION_STATUS_LABELS: Record<UserResumeValidationStatus, string> = {
  [UserResumeValidationStatus.VALIDATED]: 'Validé',
  [UserResumeValidationStatus.NOT_VALIDATED]: 'En attente de validation',
};

export const USER_RESUME_ORIGIN_LABELS: Record<UserResumeOrigin, string> = {
  [UserResumeOrigin.INTERNAL]: 'AddViseo',
  [UserResumeOrigin.CVDESIGNR]: 'CVDesignR',
};
